import * as req from 'api/actions';
import * as c from './constant';

export const createOVRS = (payload, callback) =>
  req.create(
    c.CREATE_OVRS,
    'api/v1/administrators/traffic_violators',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const getViolationsMatrixList = (
  payload = { sort_by: 'desc' },
  callback
) =>
  req.list(
    c.GET_VIOLATION_MATRIX_LIST,
    'api/v1/administrators/traffic_violations_listing',
    payload,
    callback
  );

export const getOfficers = (payload = { sort_by: 'desc', display_all: 1 }, callback) =>
  req.list(
    c.GET_OFFICERS,
    'api/v1/administrators/apprehending_officers',
    payload,
    callback
  );

export const getSelectedViolation = (id, payload, callback) =>
  req.item(
    c.GET_MATRIX_INFO,
    `api/v1/administrators/traffic_violations/${id}`,
    payload,
    callback,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const getViolationsList = (payload, callback) =>
  req.list(
    c.GET_TRANSACTION,
    'api/v1/administrators/traffic_violators/',
    payload,
    callback
  );

export const approveViolator = (id, payload, callback) =>
  req.update(
    c.APPROVE_VIOLATOR,
    `api/v1/administrators/traffic_violators/${id}`,
    payload,
    callback
  );

export const showTransactionTrafficViolator = (id, payload, callback) =>
  req.item(
    c.SHOW_TRANSACTION,
    `api/v1/administrators/traffic_violators/${id}`,
    payload,
    callback
  );

export const getPhoto = (payload = {}, callback) =>
  req.item(
    c.GET_PHOTO,
    'api/v1/administrators/birth_certificates/transaction_histories/photo',
    callback,
    payload
  );

export const getBirthcertificatesArchive = (payload = {}, callback) =>
  req.list(
    c.GET_BIRTH_ARCHIVE,
    'api/v1/administrators/birth_certificates/transaction_histories',
    payload,
    callback
  );

export const clearTransaction = () => req.setList(c.GET_TRANSACTION, []);

export const updateViolations = (id, payload, callback) =>
  req.update(
    c.EDIT_VIOLATIONS,
    `api/v1/administrators/traffic_violators/${id}`,
    payload,
    callback,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

export const updateSingleViolation = (vid, ovrid, payload, callback) =>
  req.update(
    c.EDIT_SINGLE_VIOLATIONS,
    `api/v1/administrators/traffic_violators/${ovrid}/violations/${vid}`,
    payload,
    callback,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

export const getRegionsList = (payload, callback) =>
  req.list(
    c.GET_REGION,
    'api/v1/administrators/address/regions',
    payload,
    callback
  );

export const getProvinceList = (payload, callback) =>
  req.list(
    c.GET_PROVINCE,
    'api/v1/administrators/address/provinces',
    payload,
    callback
  );

export const getMunicipalityList = (payload, callback) =>
  req.list(
    c.GET_MUNICIPALITIES,
    'api/v1/administrators/address/municipalities',
    payload,
    callback
  );

export const getBarangayList = (payload, callback) =>
  req.list(
    c.GET_BARANGAYS,
    'api/v1/administrators/address/barangays',
    payload,
    callback
  );

export const getRegionsListApp = (payload, callback) =>
  req.list(
    c.GET_APP_REGION,
    'api/v1/administrators/address/regions',
    payload,
    callback
  );

export const getProvinceListApp = (payload, callback) =>
  req.list(
    c.GET_APP_PROVINCE,
    'api/v1/administrators/address/provinces',
    payload,
    callback
  );

export const getMunicipalityListApp = (payload, callback) =>
  req.list(
    c.GET_APP_MUNICIPALITIES,
    'api/v1/administrators/address/municipalities',
    payload,
    callback
  );

export const getBarangayListApp = (payload, callback) =>
  req.list(
    c.GET_APP_BARANGAYS,
    'api/v1/administrators/address/barangays',
    payload,
    callback
  );

export const generateTransmittal = (payload, callback) =>
  req.create(
    c.GENERATE_TRANSMITTAL,
    `api/v1/administrators/ovrs/transmittal/generate`,
    payload,
    callback
  );

export const clearSelectedViolation = () => req.setList(c.GET_MATRIX_INFO, []);

export const disapproveViolator = (id, payload, callback) =>
  req.update(
    c.DISAPPROVE_VIOLATOR,
    `api/v1/administrators/traffic_violators/${id}/disapprove`,
    payload,
    callback
  );
